// Prevent the scrollbar from disappearing when the product popup modal is opened, which prevents layout shifts

document.addEventListener("DOMContentLoaded", function() {
  // Find all product popup modals
  const productModals = document.querySelectorAll(".product-popup-modal");

  if (productModals.length > 0) {
    // Add event listeners to each modal
    productModals.forEach(modal => {
      // When the modal opens (gets the 'open' attribute)
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === "attributes" && mutation.attributeName === "open") {
            if (modal.hasAttribute("open")) {
              // Modal is opening - prevent body overflow-hidden and use html class instead
              document.documentElement.classList.add("product-modal-open");
              // If body already has overflow-hidden, remove it for product modals
              if (modal.classList.contains("product-popup-modal") &&
                  document.body.classList.contains("overflow-hidden")) {
                document.body.classList.remove("overflow-hidden");
              }
            } else {
              // Modal is closing - remove our special class
              document.documentElement.classList.remove("product-modal-open");
            }
          }
        });
      });

      // Start observing the modal for attribute changes
      observer.observe(modal, { attributes: true });

      // Also handle the close button click
      const closeButton = modal.querySelector('[id^="ModalClose-"]');
      if (closeButton) {
        closeButton.addEventListener("click", () => {
          document.documentElement.classList.remove("product-modal-open");
        });
      }
    });
  }
});
